/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} MonthlyInputs */

const en_monthly = /** @type {(inputs: MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly`)
};

const de_monthly = /** @type {(inputs: MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monatlich`)
};

/**
* | output |
* | --- |
* | "Monthly" |
*
* @param {MonthlyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const monthly = /** @type {((inputs?: MonthlyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<MonthlyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_monthly(inputs)
	return de_monthly(inputs)
});